.chart {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-4);
  padding: 0;
  margin: 0;
  list-style: none;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.legendLabel {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

/* The line's own colour, in the one place colour is allowed to stand for the
   line — right beside the words that name it. */
.key {
  width: var(--space-3);
  height: 2px;
  border-radius: var(--radius-full);
  background: currentcolor;
}

.keyDashed {
  background: repeating-linear-gradient(
    to right,
    currentcolor 0 2px,
    transparent 2px var(--space-1)
  );
  border-radius: 0;
}

.plot {
  position: relative;
  /* Unitless, so the plot keeps its shape from a phone to a wide card without
     a breakpoint deciding how tall a month is. */
  aspect-ratio: 5 / 2;
  width: 100%;
}

.gridline,
.baseline,
.cursor {
  position: absolute;
  pointer-events: none;
}

.gridline {
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border);
}

.baseline {
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border-strong);
}

.cursor {
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--border-strong);
}

.scale {
  position: absolute;
  right: 0;
  transform: translateY(calc(-1 * var(--space-1)));
  padding-left: var(--space-1);
  font-size: var(--text-xs);
  color: var(--text-muted);
  background: var(--surface-raised);
  pointer-events: none;
}

.lines {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.line {
  fill: none;
  stroke: currentcolor;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.dashed {
  stroke-dasharray: 4 4;
}

/* The last reading, so a line that stops short of the end of the axis reads as
   a period still running rather than as a line that faded out. */
.head {
  position: absolute;
  width: var(--space-2);
  height: var(--space-2);
  border-radius: var(--radius-full);
  background: currentcolor;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.in {
  color: var(--money-in);
}

.out {
  color: var(--money-out);
}

.muted {
  color: var(--text-muted);
}

/* The verdict colours, not the money ones: this is a line staying the right
   side of another line, which is not a direction money moved. */
.on-track {
  color: var(--budget-on-track);
}

/* Past the line it should not have crossed. Never the only carrier of that:
   the line is below a marked threshold, and the figures beside the chart say
   so in words. */
.negative {
  color: var(--budget-missed);
}

.surface {
  position: absolute;
  inset: 0;
}

.tooltip {
  position: absolute;
  top: 0;
  z-index: 1;
  display: grid;
  gap: var(--space-1);
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-sm);
  color: var(--text-primary);
  background: var(--surface-overlay);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  transform: translateX(-50%);
  pointer-events: none;
  white-space: nowrap;
}

.tooltipDate {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.tooltipRow {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: var(--space-2);
  align-items: center;
}

.axis {
  display: flex;
  justify-content: space-between;
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.empty {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}
